import type * as lazyIndex from './lazyIndex';
import { LazyAction, LazyModule } from 'owa-bundling-light';

const MAX_FAILED_RETRIES = 100;

const lazyAnalytics: LazyModule<typeof lazyIndex> = new LazyModule<typeof lazyIndex>(
    () => import(/* webpackChunkName: "Analytics" */ './lazyIndex'),
    { maxFailedRetries: MAX_FAILED_RETRIES, name: 'Analytics' }
);

export const lazyOneDSFlush: LazyAction<typeof lazyIndex.oneDSFlush, typeof lazyAnalytics> =
    new LazyAction(lazyAnalytics, m => m.oneDSFlush);
export const lazyAddMsaAuthTicket: LazyAction<
    typeof lazyIndex.addMsaAuthTicket,
    typeof lazyAnalytics
> = new LazyAction(lazyAnalytics, m => m.addMsaAuthTicket);
export const lazyRefreshCommonPropertiesForAccount: LazyAction<
    typeof lazyIndex.refreshCommonPropertiesForAccount,
    typeof lazyAnalytics
> = new LazyAction(lazyAnalytics, m => m.refreshCommonPropertiesForAccount);
export const lazyLogDatapoint: LazyAction<typeof lazyIndex.logDatapoint, typeof lazyAnalytics> =
    new LazyAction(lazyAnalytics, m => m.logDatapoint);
export const lazyLogPerformanceDatapoint: LazyAction<
    typeof lazyIndex.logPerformanceDatapoint,
    typeof lazyAnalytics
> = new LazyAction(lazyAnalytics, m => m.logPerformanceDatapoint);
export const lazyGetResourceTimingForUrl: LazyAction<
    typeof lazyIndex.getResourceTimingForUrl,
    typeof lazyAnalytics
> = new LazyAction(lazyAnalytics, m => m.getResourceTimingForUrl);

export const lazyLogAddinsCustomerContent: LazyAction<
    typeof lazyIndex.logAddinsCustomerContent,
    typeof lazyAnalytics
> = new LazyAction(lazyAnalytics, m => m.logAddinsCustomerContent);

export const lazyLogAddinsTelemetryEvent: LazyAction<
    typeof lazyIndex.logAddinsTelemetryEvent,
    typeof lazyAnalytics
> = new LazyAction(lazyAnalytics, m => m.logAddinsTelemetryEvent);

export const lazyLogUsage: LazyAction<typeof lazyIndex.logUsage, typeof lazyAnalytics> =
    new LazyAction(lazyAnalytics, m => m.logUsage);
export const lazyTrackNetworkResponse: LazyAction<
    typeof lazyIndex.trackNetworkResponse,
    typeof lazyAnalytics
> = new LazyAction(lazyAnalytics, m => m.trackNetworkResponse);

export const lazyLogProfilerDatapoint: LazyAction<
    typeof lazyIndex.logProfilerDatapoint,
    typeof lazyAnalytics
> = new LazyAction(lazyAnalytics, m => m.logProfilerDatapoint);

export const lazyInitializeAnalytics: LazyAction<
    typeof lazyIndex.initializeAnalytics,
    typeof lazyAnalytics
> = new LazyAction(lazyAnalytics, m => m.initializeAnalytics);

export const lazyLogSecondaryAccountSessionDatapoint: LazyAction<
    typeof lazyIndex.logSecondaryAccountSessionDatapoint,
    typeof lazyAnalytics
> = new LazyAction(lazyAnalytics, m => m.logSecondaryAccountSessionDatapoint);

export const lazySetGlobalAnalyticsListeners: LazyAction<
    typeof lazyIndex.setGlobalAnalyticsListeners,
    typeof lazyAnalytics
> = new LazyAction(lazyAnalytics, m => m.setGlobalAnalyticsListeners);
